import { render } from "./ModalConfirmDelete.vue?vue&type=template&id=15ca278d&scoped=true"
import script from "./ModalConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDelete.vue?vue&type=script&lang=js"

import "./ModalConfirmDelete.vue?vue&type=style&index=0&id=15ca278d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ca278d"]])

export default __exports__